module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Moorland Forensics -"), _c('br'), _vm._v(" Aftershock")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#preface-belfast-northern-ireland-1989"
    }
  }, [_vm._v("Preface: Belfast, Northern Ireland, 1989")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#capitol-of-the-republic-pretoria-south-africa-the-year-2005"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-one-present-day"
    }
  }, [_vm._v("Chapter One: Present Day")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-two"
    }
  }, [_vm._v("Chapter Two")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#chapter-three"
    }
  }, [_vm._v("Chapter Three")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-six",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#sister-accuses-brother-of-murder",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#forensic-scientistdrunk-under-the-microscope-of-life",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-seven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-eight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-nine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#media-police-update-the-mercure-hotel-exeter-one-week-later",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-ten",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-eleven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#moretonhampstead-february-2018",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-twelve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#nicks-office-exeter-10-days-later",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#moretonhampstead-february-2019",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#moretonhampstead-august-2018",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-thirteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-fourteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chicago-oak-park-25-april-1997",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#university-of-chicago-25-april-1997",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#six-months-after-the-bomb-blast-on-the-dartmouth-oyster",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-fifteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#may-2017",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#may-2017-grays-law-firm-exeter",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#south-hams-medical-centre-devon-february-2018",
      "title": "Link target outside of Sample"
    }
  })]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#september-2018",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-sixteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#one-week-later-lunchtime-nick-shelbys-laboratory-exeter-forensic-centre",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-seventeen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-eighteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#seven-years-after-antrim",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-nineteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0